import { useState, createContext, useEffect } from "react";
import "./App.css";
import UserInterface from "./components/UserInterface";
import Scene from "./components/Scene/Scene";
import CanvasIcons from "./components/CanvasIcons/CanvasIcons";

import './i18n';
import { useTranslation } from "react-i18next";

export const ProductContext = createContext({});
export const MountingContext = createContext({});

function App() {
  const [currentProduct, setCurrentProduct] = useState(null);
  const [wall, setWall] = useState(null);
  const [currentConfiguration, setCurrentConfiguration] = useState("1700a");
  const [currentColor, setCurrentColor] = useState("0x222827");
  const [selectedWing, setSelectedWing] = useState("wingLeft");
  const [topMounting, setTopMounting] = useState(true);
  const [rightMounting, setRightMounting] = useState(true);
  const [bottomMounting, setBottomMounting] = useState(true);
  const [leftMounting, setLeftMounting] = useState(true);
  const [documentDirection, setDocumentDirection] = useState("ltr");
  const { i18n } = useTranslation();

  useEffect(() => {
    setDocumentDirection(i18n.dir());
  }, [i18n, i18n.language]);

  return (
    <ProductContext.Provider
      value={{
        currentProduct,
        setCurrentProduct,
        wall,
        setWall,
        currentConfiguration,
        setCurrentConfiguration,
        currentColor,
        setCurrentColor
      }}
    >
      <MountingContext.Provider
        value={{
          topMounting,
          setTopMounting,
          selectedWing,
          setSelectedWing,
          rightMounting,
          setRightMounting,
          bottomMounting,
          setBottomMounting,
          leftMounting,
          setLeftMounting,
        }}
      >
        <CanvasIcons />
        <div className="window-container">
          <div className="canvas-container">
            <Scene productConfiguration={currentConfiguration} productColor={currentColor} />
          </div>
          <UserInterface documentDirection={documentDirection}  />
        </div>
      </MountingContext.Provider>
    </ProductContext.Provider>
  );
}

export default App;
